<template>
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 62 64"
  >
    <path d="M31,2C13.88,2,0,15.88,0,33s13.88,31,31,31,31-13.87,31-31S48.12,2,31,2h0Z" />
    <path
      fill="#fff"
      d="M59.5,33c0,15.72-12.78,28.5-28.5,28.5S2.5,48.71,2.5,33,15.29,4.5,31,4.5s28.5,12.78,28.5,28.5Z"
    />
    <path d="M31,7c-14.34,0-26,11.66-26,26s11.66,26,26,26,26-11.66,26-26S45.34,7,31,7h0Z" />
    <path
      fill="#fff"
      d="M31,33.34c2.9,0,5.47.69,7.55,1.6,1.92.85,3.13,2.78,3.13,4.86v2.89h-21.37v-2.87c0-2.1,1.21-4.03,3.13-4.86,2.08-.93,4.65-1.62,7.55-1.62ZM16.75,33.78c1.96,0,3.56-1.6,3.56-3.56s-1.6-3.56-3.56-3.56-3.56,1.6-3.56,3.56,1.6,3.56,3.56,3.56ZM18.76,35.74c-.66-.11-1.32-.18-2.01-.18-1.76,0-3.44.37-4.95,1.03-1.32.57-2.17,1.85-2.17,3.3v2.8h8.02v-2.87c0-1.48.41-2.87,1.12-4.08ZM45.25,33.78c1.96,0,3.56-1.6,3.56-3.56s-1.6-3.56-3.56-3.56-3.56,1.6-3.56,3.56,1.6,3.56,3.56,3.56ZM52.37,39.89c0-1.44-.85-2.73-2.17-3.3-1.51-.66-3.19-1.03-4.95-1.03-.69,0-1.35.07-2.01.18.71,1.21,1.12,2.6,1.12,4.08v2.87h8.02v-2.8ZM31,21.31c2.96,0,5.34,2.39,5.34,5.34s-2.39,5.34-5.34,5.34-5.34-2.39-5.34-5.34,2.39-5.34,5.34-5.34Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'BuildingIcon',
};
</script>
